import React from "react";
import PropTypes from "prop-types";
import "./ClosableLabel.scss";
import CloseIcon from "./close.svg";

const ClosableLabel = ({ children, onClose }) => (
  <span className="closable-label">
    <span className="closable-label__text">{children}</span>
    <i onClick={onClose} />
  </span>
);

ClosableLabel.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ClosableLabel;
